import {useViewSpecQuery} from '../../generated/graphql';
import {parsedReportSpec, SlateReport} from './';

export function useParsedReportSpec(reportID: string): SlateReport | undefined {
  const {data: viewQueryData} = useViewSpecQuery({variables: {id: reportID}});

  const spec = viewQueryData?.view?.spec;
  if (!spec) {
    return undefined;
  }

  const viewType = viewQueryData?.view?.type;
  if (viewType !== 'runs' && viewType !== 'runs/draft') {
    console.error('Invalid view type for report:', viewType);
    return undefined;
  }

  return parsedReportSpec(JSON.parse(spec), viewType);
}
